module.exports = __webpack_public_path__ + "img/IMG_0404-1200w.15b14682.jpg";